import { countySlug } from '../constants/counties';

// Szolgáltatói landing oldalak (SEO): /szolgaltatok/:kategoria, /szolgaltatok/:kategoria/:megye,
// /szolgaltatok/helyszin/:megye. A "helyszin" fenntartott szegmens, kategória nem kaphatja slugként.
export const COUNTY_ONLY_SEGMENT = 'helyszin';

export const providersLandingPath = ({ categorySlug, county } = {}) => {
  const county_ = county ? countySlug(county) : null;
  if (categorySlug && county_) return `/szolgaltatok/${categorySlug}/${county_}`;
  if (categorySlug) return `/szolgaltatok/${categorySlug}`;
  if (county_) return `/szolgaltatok/${COUNTY_ONLY_SEGMENT}/${county_}`;
  return '/szolgaltatok';
};

// Slug nélküli kategóriánál (régebbi API-válasz) a query-s lista, ami a landing canonicalra mutat
export const categoryLandingPath = (category) =>
  category.slug ? providersLandingPath({ categorySlug: category.slug }) : `/szolgaltatok?category=${category.id}`;

// Budapest nem megye, a többinél a megszokott "X megye" alak
export const countyLabel = (county) => (county === 'Budapest' ? 'Budapest' : `${county} megye`);
